import React from "react";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandleContext } from './DragHandleContext';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Tr with dynamic content
 * @param JSX.Element children: Text or JSX element (required)
 * @param String classes: Add extra classNames for <tr> (optional)
 * @param Boolean sortable: Enable drag-and-drop sorting (optional, default false)
 * @param {string|number} id: Unique identifier for sortable mode (required when sortable=true)
 * @returns {JSX.Element}
 */
const CustomTr = ({ children, classes, sortable = false, id }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: id ?? 'no-id', disabled: !sortable });

    const style = sortable ? {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: isDragging ? 'relative' : undefined,
    } : {};

    return (
        <DragHandleContext.Provider value={sortable ? listeners : {}}>
            <tr
                ref={sortable ? setNodeRef : undefined}
                style={style}
                className={`${classes ?? ''} ${sortable ? 'tr-sortable' : ''} ${sortable && isDragging ? 'card-accent-50 tr-dragging' : ''}`}
                {...(sortable ? attributes : {})}
            >
                {children}
            </tr>
        </DragHandleContext.Provider>
    );
};

export default CustomTr;
